import {AuthActionCreators} from "./auth/action-creators";
import {GameActionCreators} from "./game/action-creators";
import {AnimationActionCreators} from "./animation/action-creation";


export const allActionCreators = {
    ...AuthActionCreators,
    ...GameActionCreators,
    ...AnimationActionCreators
}
